import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Der er for alle materialeprøver anvendt grænseværdier, som er angivet i nedenstående tabeller i henhold til forvaltningsgrundlaget fra Sjællandsnetværket for bygge og anlægsaffald (2). ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Farvemarkering viser hvilken affaldskategori den pågældende prøve hører ind under: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Grøn: (Grøn firkant) Rent affald, ikke forurenet affald"),
  /*#__PURE__*/_createElementVNode("li", null, "Gul: (Gul firkant) Forurenet, ikke farligt affald"),
  /*#__PURE__*/_createElementVNode("li", null, "Rød: (rød firkant) Farligt affald")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Grænseværdier for indhold af miljøproblematiske stoffer i byggeaffald", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      rowspan: "2"
    }, "Stof"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "Klassificering/grænseværdi mg/kg")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Uforurenet"),
    /*#__PURE__*/_createElementVNode("th", null, "Forurenet"),
    /*#__PURE__*/_createElementVNode("th", null, "Farligt")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Tungmetaller")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Arsen (As)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Bly (Pb)"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Cadmium (Cd)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Kobber (Cu)"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Krom (Cr-total)", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Krom (Cr-VI)", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Kviksølv (Hg, organisk)"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Kviksølv (Hg, uorganisk)"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Nikkel (Ni)", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Zink (Zn)"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "PAH'er")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "PAH sum", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Klorparaffiner")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Kortkædet"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Mellemkædet"),
  /*#__PURE__*/_createElementVNode("sup", null, "1")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "PCB")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("PCB (PCB total)"),
  /*#__PURE__*/_createElementVNode("sup", null, "34")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Cyanid")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Cyanid total", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode("(5)"),
  /*#__PURE__*/_createElementVNode("sup", { hidden: "true" }, "4")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createTextVNode("(5)"),
  /*#__PURE__*/_createElementVNode("sup", { hidden: "true" }, "4")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Asbest")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Asbest"),
    /*#__PURE__*/_createElementVNode("td", null, "Ikke påvist"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td", null, "Påvist")
  ])
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      rowspan: "2"
    }, "Stof"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "Klassificering/grænseværdi mg/kg")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Uforurenet"),
    /*#__PURE__*/_createElementVNode("th", null, "Forurenet"),
    /*#__PURE__*/_createElementVNode("th", null, "Farligt")
  ])
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Kulbrinter")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "C6-C10", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("C10-C15"),
  /*#__PURE__*/_createElementVNode("sup", null, "5")
], -1)
const _hoisted_38 = {
  class: "ContainsTable",
  rowspan: "2"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "40", -1)
const _hoisted_40 = { rowspan: "2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "55")
], -1)
const _hoisted_42 = { rowspan: "2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("sup", null, "6", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("C15-C20"),
  /*#__PURE__*/_createElementVNode("sup", null, "5")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "C20-C35/40", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { scope: "row" }, "Total C6-C35/40", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", null, "Forklaringer til ovenstående information", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("ol", { class: "ListNumber Small" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Stofferne mærket med "),
      /*#__PURE__*/_createElementVNode("sup", null, "1"),
      /*#__PURE__*/_createTextVNode(" er omfattet af summeringsreglerne for HP 14 \"Økotoks\" gældende fra 5. juli 2018. Hvis koncentrationen af de enkelte stoffer er mellem 1.000 og 2.500 ppm, skal de lægges sammen. Hvis den samlede værdi overstiger 2.500 ppm, er det farligt affald. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Der er endnu ikke fastsat grænseværdier for Krom total og Krom III i henhold til ECHA (Det Europæiske Kemikalieagentur) og CLP (klassificering, mærkning og emballering af kemikalier), men Sjællandsnetværket for bygge- og anlægsaffald benytter denne grænseværdi indtil videre. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Eventuelt nyttiggørelse, jf. restproduktbekendtgørelsens § 16, jf. Bilag 3, med et maksimalt indhold af PCB op til 2,0 ppm (målt ved kilden og i overfladen det sted, hvor koncentrationen vurderes at være højest) skal anmeldes til kommunen fire uger før anvendelsen. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Der er følgende grænseværdier for farligt affald for de enkelte cyanidforbindelser: For Ca(CN)2, HCN og Cd(CN)2 er grænsen 2.500 mg/kg. (forbindelserne er omfattet af summeringsreglerne, se punkt 1). Grænseværdien for HCN Ni(CN)2 er 1.000 mg/kg. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Tallene for uforurenet affald tager udgangspunkt i jordkvalitetskriterierne, hvor intervallet C10-C20 er opdelt, hvilket ikke gør sig gældende ved klassificering af farligt affald. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " Hvis analyseresultaterne for de enkelte kulbrinteintervaller er under 1.000 mg/kg, skal affaldet klassificeres som ikke farligt affald. Hvis koncentrationen er over 10.000 mg/kg, skal affaldet klassificeres som farligt affald. ")
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "PDFReferenceList" }, [
  /*#__PURE__*/_createElementVNode("h3", { id: "aria-reference-header" }, "Referencer"),
  /*#__PURE__*/_createElementVNode("ol", { "aria-labelledby": "aria-reference-header" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" (2) "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://dakofa.dk/oevrige/baaps/",
        target: "_blank"
      }, "Forvaltningsgrundlaget")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFPage = _resolveComponent("PDFPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PDFPage, {
      class: "PDFParadigmValues",
      contentClasses: 'PDFRichText',
      context: _ctx.context
    }, {
      sectionTitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.section) + ". " + _toDisplayString(_ctx.mixWB('LIMIT_VALUES_FOR_ENVIRONMENTALLY_PROBLEMATIC_SUBSTANCES')), 1)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("table", null, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            _hoisted_6,
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 20", 1),
              _createElementVNode("td", null, " 20 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 40", 1),
              _createElementVNode("td", null, " 40 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 2.500", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 0,5", 1),
              _createElementVNode("td", null, " 0,5 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 500", 1),
              _createElementVNode("td", null, " 500 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 2.500", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 500", 1),
              _createElementVNode("td", null, [
                _createTextVNode(" 500 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
                _hoisted_12
              ]),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 20", 1),
              _createElementVNode("td", null, " 20 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 1", 1),
              _createElementVNode("td", null, " 1 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 2.500", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_15,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 1", 1),
              _createElementVNode("td", null, " 1 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 2.500", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 30", 1),
              _createElementVNode("td", null, " 30 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 500", 1),
              _createElementVNode("td", null, " 500 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 2.500", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _hoisted_18,
            _createElementVNode("tr", null, [
              _hoisted_19,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 4", 1),
              _createElementVNode("td", null, "4 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _hoisted_20,
            _createElementVNode("tr", null, [
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 2.500", 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _hoisted_27,
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 0,1", 1),
              _createElementVNode("td", null, " 0,1 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 50", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 50", 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _hoisted_29,
            _createElementVNode("tr", null, [
              _hoisted_30,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 1", 1),
              _hoisted_31,
              _hoisted_32
            ])
          ]),
          _hoisted_33
        ])
      ]),
      _: 1
    }, 8, ["context"]),
    _createVNode(_component_PDFPage, {
      class: "PDFParadigmValues",
      contentClasses: 'PDFRichText',
      context: _ctx.context
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", null, [
          _hoisted_34,
          _createElementVNode("tbody", null, [
            _hoisted_35,
            _createElementVNode("tr", null, [
              _hoisted_36,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 25", 1),
              _createElementVNode("td", null, " 25 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_37,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 40", 1),
              _createElementVNode("td", _hoisted_38, [
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_39,
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.signs.belowOrEqual) + " Sum (konc C10-20) " + _toDisplayString(_ctx.signs.below) + " 1.000 ", 1)
                  ]),
                  _hoisted_41
                ])
              ]),
              _createElementVNode("td", _hoisted_42, [
                _createTextVNode("konc. C10-C20 " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1),
                _hoisted_43
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_44,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 55", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_45,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 100", 1),
              _createElementVNode("td", null, " 100 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_46,
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.below) + " 100", 1),
              _createElementVNode("td", null, " 100 " + _toDisplayString(_ctx.signs.belowOrEqual) + " konc. " + _toDisplayString(_ctx.signs.below) + " 1.000", 1),
              _createElementVNode("td", null, "Konc. " + _toDisplayString(_ctx.signs.aboveOrEqual) + " 1.000", 1)
            ])
          ])
        ]),
        _hoisted_47,
        _hoisted_48,
        _hoisted_49
      ]),
      _: 1
    }, 8, ["context"])
  ], 64))
}